export function menuProjectIndexRequest(filters) {
  return {
    type: '@menu/projects/INDEX_REQUEST',
    payload: { filters },
  };
}

export function menuProjectIndexSuccess(data) {
  return {
    type: '@menu/projects/INDEX_SUCCESS',
    payload: { data },
  };
}

export function menuProjectIndexFailure() {
  return {
    type: '@menu/projects/INDEX_FAILURE',
  };
}